<template>
  <q-drawer
    v-model="localValue"
    :width="parseInt(width)"
    behavior="desktop"
    overlay
    :side="position"
    :elevated="false"
    :content-class="'text-' + textColor + ' bg-' + bgColor"
  >
    <q-scroll-area class="fit">
      <div
        :class="
          'q-px-md q-py-sm' +
          ' text-' +
          headerTextColor +
          ' bg-' +
          headerBgColor
        "
      >
        {{ headerTitle }}
      </div>
      <q-list separator :dark="darkSeparator">
        <q-item
          @click="itemClick(i)"
          clickable
          v-ripple
          v-for="(item, i) in pages"
          :key="'page' + i"
        >
          <q-item-section v-if="showPageNumber" side>
            {{ i + 1 }}
          </q-item-section>
          <q-item-section>
            <q-item-label
              style="font-size: 13px"
              lines="1"
              v-html="pascalCase(item.title)"
            ></q-item-label>
          </q-item-section>
          <q-item-section side>
            <q-icon name="chevron_right" />
          </q-item-section>
          <q-tooltip>{{ pascalCase(item.title) }}</q-tooltip>
        </q-item>
      </q-list>
    </q-scroll-area>
  </q-drawer>
</template>

<script>
import mixin from "./d-card-mixins";

export default {
  name: "DCardMenu",
  mixins: [mixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    pages: {
      type: Array,
      default: () => new Array(),
    },
    showPageNumber: {
      type: Boolean,
      default: false,
    },
    bgColor: {
      type: String,
      default: "dark",
    },
    textColor: {
      type: String,
      default: "white",
    },
    headerBgColor: {
      type: String,
      default: "dark",
    },
    headerTextColor: {
      type: String,
      default: "white",
    },
    darkSeparator: {
      type: Boolean,
      default: false,
    },
    headerTitle: {
      type: String,
      default: "Menu",
    },
    width: {
      default: 250,
    },
    position: {
      default: "left",
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    itemClick(index) {
      this.$emit("click", index);
      this.localValue = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./d-card.scss');
</style>
